type UserLike = {
  full_name?: string | null;
  email?: string | null;
};

const FALLBACK_AVATAR = "https://www.gravatar.com/avatar/?d=mp&s=128";

export const getUserInitial = (fullName?: string | null) => {
  if (!fullName) return "U";
  return fullName.trim().charAt(0).toUpperCase() || "U";
};

export const getUserAvatarUrl = (user: UserLike, size = 96) => {
  const email = user.email?.trim().toLowerCase();
  if (!email) {
    return FALLBACK_AVATAR;
  }

  return `https://unavatar.io/${encodeURIComponent(email)}?fallback=${encodeURIComponent(FALLBACK_AVATAR)}&size=${size}`;
};
